import React from 'react';

const TestComponent: React.FC = () => {
  return (
    <div className="min-h-screen bg-vista-silver-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-lg p-8 border border-vista-silver-200 text-center">
        <h1 className="text-3xl font-bold text-vista-silver-900 mb-4">
          VistaCalc Frontend Test
        </h1>
        <p className="text-vista-silver-600 mb-6">
          If you can see this styled component, the frontend setup is working correctly!
        </p>
        <div className="space-y-4">
          <div className="bg-vista-teal-50 border border-vista-teal-200 rounded-xl p-4">
            <p className="text-vista-teal-900 font-medium">✅ Tailwind CSS is working</p>
          </div>
          <div className="bg-vista-silver-50 border border-vista-silver-200 rounded-xl p-4">
            <p className="text-vista-silver-900 font-medium">✅ Custom colors are applied</p>
          </div>
          <div className="bg-gradient-to-r from-vista-teal-500 to-vista-teal-600 text-white rounded-xl p-4">
            <p className="font-medium">✅ Gradients are working</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestComponent;
